import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { checkSeriesDataXDateGreaterThanMin } from "./utils/checkSeriesDataXDateGreaterThanMin";
import { convertToNumber } from "./utils/convertToNumber";

export function cagrLocks(states: Partial<EvaChartStates>) {
  const { locks, series } = states;

  const lockedXMax = locks?.xMax?.value;
  let lockedYMin = locks?.yMin?.value ?? -50;
  let lockedYMax = locks?.yMax?.value ?? 100; // no product locks here as chart specific lock always overrides
  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset
      ? undefined
      : locks?.xMin?.value ?? checkSeriesDataXDateGreaterThanMin("2000", series);

  if (locks?.yMin?.type === DataEnum.Reset) lockedYMin = undefined;
  if (locks?.yMax?.type === DataEnum.Reset) lockedYMax = undefined;

  return {
    lockedXMin: lockedXMin,
    lockedXMax: lockedXMax,
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
